import { useCreateMutation } from '../../CRUD';
import { axiosService } from '../../services/axiosService';
import { lumaBotFlowBaseModel } from './crud';
import { ILumaBotFlowQuestion } from './types';

export interface TUseLumaBotFlowCreateAnswerParams {
  queryParams: {
    flowId: string;
  };
  body?: {
    text?: string;
    id?: string;
    details?: any;
  };
}

export interface TUseLumaBotFlowCreateAnswerResponse
  extends Array<ILumaBotFlowQuestion> {}

export const useLumaBotFlowCreateAnswer = () => {
  const { keysV2 } = lumaBotFlowBaseModel;

  async function queryFn({
    queryParams: { flowId },
    body = {},
  }: TUseLumaBotFlowCreateAnswerParams) {
    const { data } = await axiosService.post(
      `${keysV2.basicUrlPath}/${flowId}/answer`,
      body,
    );

    return data;
  }

  return useCreateMutation<
    TUseLumaBotFlowCreateAnswerResponse,
    TUseLumaBotFlowCreateAnswerParams
  >(keysV2.all, queryFn);
};
